//
// Turns a float seconds number into a time
//
//
//
import displayNumberDigits from '../strings/displayNumberDigits';

const secondsToTime = (floatSeconds, blink = false) => {
  const hours = Math.floor(floatSeconds / (60 * 60));
  let remain = floatSeconds - (hours * 60 * 60);
  const minutes = Math.floor(remain / 60);
  remain -= minutes * 60;
  const seconds = Math.floor(remain);
  const tenthsSecond = Math.floor((remain - seconds) * 10);

  if (blink) {
    const separator = (tenthsSecond >= 5) ? ' ' : ':';
    if (hours) return `${hours}${separator}${displayNumberDigits(minutes, 2)}`;

    if (minutes) return `${minutes}${separator}${displayNumberDigits(seconds, 2)}`;

    return `${seconds}${separator}${displayNumberDigits(tenthsSecond, 1)}`;
  }

  if (hours) return `${hours}h${displayNumberDigits(minutes, 2)}s`;

  if (minutes) return `${minutes}m${displayNumberDigits(seconds, 2)}s`;

  return `${seconds},${displayNumberDigits(tenthsSecond, 1)}s`;
};

export default secondsToTime;
